export default "__VITE_ASSET__95ksrEHk__"